var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatDoazgpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3345_2647",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 32,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8145 17.4009C27.8145 17.79 27.5462 18.2852 27.2162 18.4974L23.662 20.7967C23.332 21.0089 23.0637 20.8651 23.0637 20.4736V3.98741C23.0637 3.5983 23.3842 3.27759 23.7784 3.27759H27.0999C27.4916 3.27759 27.8145 3.59595 27.8145 3.98741V17.4009Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3334 13.0123C20.6349 13.2622 20.8439 13.7857 20.8011 14.1725L20.331 18.2994C20.2859 18.6861 20.0034 18.7993 19.7042 18.5493L11.8575 12.0218C11.556 11.7718 11.5156 11.3214 11.7673 11.0219L13.8542 8.54582C14.1059 8.24633 14.5594 8.20624 14.8609 8.45621L20.3358 13.0099L20.3334 13.0123Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.567 16.6227C13.2797 16.3585 12.7289 16.2123 12.3466 16.2972L12.3443 16.2949L5.37837 17.8584C4.99613 17.9456 4.75396 18.3276 4.83943 18.7073L5.51608 21.6834C5.60392 22.063 5.98854 22.3036 6.37079 22.2187L16.3543 19.9784C16.7389 19.8935 16.8149 19.6058 16.5276 19.3417L13.567 16.6227Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1505 24.2798C10.3262 23.9307 10.7891 23.6053 11.1785 23.5581L15.3167 23.0511C15.7061 23.004 15.8818 23.2492 15.7061 23.5982L11.1358 32.6938C10.9601 33.0428 10.5304 33.1867 10.179 33.0122L7.28245 31.576C6.93107 31.4015 6.78625 30.9747 6.96194 30.6257L10.1505 24.2798Z",
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.312 30.2012C15.1173 30.5408 15.0959 31.1068 15.2645 31.4581V31.4628L18.3225 37.8724C18.491 38.2238 18.9208 38.3771 19.2745 38.2097L21.9835 36.9339C22.3372 36.7664 22.4916 36.3396 22.323 35.9882L17.9402 26.8007C17.7717 26.4469 17.4749 26.4352 17.2802 26.7747L15.312 30.2012Z",
    fill: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8022 31.9227C23.4247 31.8189 23.0068 31.4322 22.8763 31.0643L21.5515 27.3383C21.4209 26.9705 21.6227 26.7535 22.0026 26.8596L31.8674 29.5668C32.2449 29.6706 32.4704 30.0644 32.3659 30.4394L31.5658 33.3164C31.4614 33.6913 31.0649 33.9154 30.6874 33.8116L23.8046 31.9227H23.8022Z",
    fill: "#D9D9D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0329 26.0036C28.408 26.1192 28.9684 26.0177 29.277 25.7772L29.2746 25.7749L34.8944 21.4004C35.203 21.1598 35.2576 20.7118 35.0154 20.4052L33.1374 18.0234C32.8953 17.7169 32.4442 17.6626 32.1355 17.9032L24.0799 24.1736C23.7712 24.4142 23.8258 24.7066 24.201 24.8221L28.0329 26.0036Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3345_2647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8145 17.4009C27.8145 17.79 27.5462 18.2852 27.2162 18.4974L23.662 20.7967C23.332 21.0089 23.0637 20.8651 23.0637 20.4736V3.98741C23.0637 3.5983 23.3842 3.27759 23.7784 3.27759H27.0999C27.4916 3.27759 27.8145 3.59595 27.8145 3.98741V17.4009Z",
    fill: "url(#paint0_linear_3345_2647)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8145 17.4009C27.8145 17.79 27.5462 18.2852 27.2162 18.4974L23.662 20.7967C23.332 21.0089 23.0637 20.8651 23.0637 20.4736V3.98741C23.0637 3.5983 23.3842 3.27759 23.7784 3.27759H27.0999C27.4916 3.27759 27.8145 3.59595 27.8145 3.98741V17.4009Z",
    fill: "url(#paint1_linear_3345_2647)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8145 17.4009C27.8145 17.79 27.5462 18.2852 27.2162 18.4974L23.662 20.7967C23.332 21.0089 23.0637 20.8651 23.0637 20.4736V3.98741C23.0637 3.5983 23.3842 3.27759 23.7784 3.27759H27.0999C27.4916 3.27759 27.8145 3.59595 27.8145 3.98741V17.4009Z",
    fill: "url(#paint2_linear_3345_2647)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3334 13.0123C20.6349 13.2622 20.8439 13.7857 20.8011 14.1725L20.331 18.2994C20.2859 18.6861 20.0034 18.7993 19.7042 18.5493L11.8575 12.0218C11.556 11.7718 11.5156 11.3214 11.7673 11.0219L13.8542 8.54582C14.1059 8.24633 14.5594 8.20624 14.8609 8.45621L20.3358 13.0099L20.3334 13.0123Z",
    fill: "url(#paint3_linear_3345_2647)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3334 13.0123C20.6349 13.2622 20.8439 13.7857 20.8011 14.1725L20.331 18.2994C20.2859 18.6861 20.0034 18.7993 19.7042 18.5493L11.8575 12.0218C11.556 11.7718 11.5156 11.3214 11.7673 11.0219L13.8542 8.54582C14.1059 8.24633 14.5594 8.20624 14.8609 8.45621L20.3358 13.0099L20.3334 13.0123Z",
    fill: "url(#paint4_linear_3345_2647)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3334 13.0123C20.6349 13.2622 20.8439 13.7857 20.8011 14.1725L20.331 18.2994C20.2859 18.6861 20.0034 18.7993 19.7042 18.5493L11.8575 12.0218C11.556 11.7718 11.5156 11.3214 11.7673 11.0219L13.8542 8.54582C14.1059 8.24633 14.5594 8.20624 14.8609 8.45621L20.3358 13.0099L20.3334 13.0123Z",
    fill: "url(#paint5_linear_3345_2647)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.567 16.6227C13.2797 16.3585 12.7289 16.2123 12.3466 16.2972L12.3443 16.2949L5.37837 17.8584C4.99613 17.9456 4.75396 18.3276 4.83943 18.7073L5.51608 21.6834C5.60392 22.063 5.98854 22.3036 6.37079 22.2187L16.3543 19.9784C16.7389 19.8935 16.8149 19.6058 16.5276 19.3417L13.567 16.6227Z",
    fill: "url(#paint6_linear_3345_2647)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.567 16.6227C13.2797 16.3585 12.7289 16.2123 12.3466 16.2972L12.3443 16.2949L5.37837 17.8584C4.99613 17.9456 4.75396 18.3276 4.83943 18.7073L5.51608 21.6834C5.60392 22.063 5.98854 22.3036 6.37079 22.2187L16.3543 19.9784C16.7389 19.8935 16.8149 19.6058 16.5276 19.3417L13.567 16.6227Z",
    fill: "url(#paint7_linear_3345_2647)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.567 16.6227C13.2797 16.3585 12.7289 16.2123 12.3466 16.2972L12.3443 16.2949L5.37837 17.8584C4.99613 17.9456 4.75396 18.3276 4.83943 18.7073L5.51608 21.6834C5.60392 22.063 5.98854 22.3036 6.37079 22.2187L16.3543 19.9784C16.7389 19.8935 16.8149 19.6058 16.5276 19.3417L13.567 16.6227Z",
    fill: "url(#paint8_linear_3345_2647)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1505 24.2798C10.3262 23.9307 10.7891 23.6053 11.1785 23.5581L15.3167 23.0511C15.7061 23.004 15.8818 23.2492 15.7061 23.5982L11.1358 32.6938C10.9601 33.0428 10.5304 33.1867 10.179 33.0122L7.28245 31.576C6.93107 31.4015 6.78625 30.9747 6.96194 30.6257L10.1505 24.2798Z",
    fill: "url(#paint9_linear_3345_2647)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1505 24.2798C10.3262 23.9307 10.7891 23.6053 11.1785 23.5581L15.3167 23.0511C15.7061 23.004 15.8818 23.2492 15.7061 23.5982L11.1358 32.6938C10.9601 33.0428 10.5304 33.1867 10.179 33.0122L7.28245 31.576C6.93107 31.4015 6.78625 30.9747 6.96194 30.6257L10.1505 24.2798Z",
    fill: "url(#paint10_linear_3345_2647)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1505 24.2798C10.3262 23.9307 10.7891 23.6053 11.1785 23.5581L15.3167 23.0511C15.7061 23.004 15.8818 23.2492 15.7061 23.5982L11.1358 32.6938C10.9601 33.0428 10.5304 33.1867 10.179 33.0122L7.28245 31.576C6.93107 31.4015 6.78625 30.9747 6.96194 30.6257L10.1505 24.2798Z",
    fill: "url(#paint11_linear_3345_2647)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.312 30.2012C15.1173 30.5408 15.0959 31.1068 15.2645 31.4581V31.4628L18.3225 37.8724C18.491 38.2238 18.9208 38.3771 19.2745 38.2097L21.9835 36.9339C22.3372 36.7664 22.4916 36.3396 22.323 35.9882L17.9402 26.8007C17.7717 26.4469 17.4749 26.4352 17.2802 26.7747L15.312 30.2012Z",
    fill: "url(#paint12_linear_3345_2647)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.312 30.2012C15.1173 30.5408 15.0959 31.1068 15.2645 31.4581V31.4628L18.3225 37.8724C18.491 38.2238 18.9208 38.3771 19.2745 38.2097L21.9835 36.9339C22.3372 36.7664 22.4916 36.3396 22.323 35.9882L17.9402 26.8007C17.7717 26.4469 17.4749 26.4352 17.2802 26.7747L15.312 30.2012Z",
    fill: "url(#paint13_linear_3345_2647)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.312 30.2012C15.1173 30.5408 15.0959 31.1068 15.2645 31.4581V31.4628L18.3225 37.8724C18.491 38.2238 18.9208 38.3771 19.2745 38.2097L21.9835 36.9339C22.3372 36.7664 22.4916 36.3396 22.323 35.9882L17.9402 26.8007C17.7717 26.4469 17.4749 26.4352 17.2802 26.7747L15.312 30.2012Z",
    fill: "url(#paint14_linear_3345_2647)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8022 31.9227C23.4247 31.8189 23.0068 31.4322 22.8763 31.0643L21.5515 27.3383C21.4209 26.9705 21.6227 26.7535 22.0026 26.8596L31.8674 29.5668C32.2449 29.6706 32.4704 30.0644 32.3659 30.4394L31.5658 33.3164C31.4614 33.6913 31.0649 33.9154 30.6874 33.8116L23.8046 31.9227H23.8022Z",
    fill: "url(#paint15_linear_3345_2647)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8022 31.9227C23.4247 31.8189 23.0068 31.4322 22.8763 31.0643L21.5515 27.3383C21.4209 26.9705 21.6227 26.7535 22.0026 26.8596L31.8674 29.5668C32.2449 29.6706 32.4704 30.0644 32.3659 30.4394L31.5658 33.3164C31.4614 33.6913 31.0649 33.9154 30.6874 33.8116L23.8046 31.9227H23.8022Z",
    fill: "url(#paint16_linear_3345_2647)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8022 31.9227C23.4247 31.8189 23.0068 31.4322 22.8763 31.0643L21.5515 27.3383C21.4209 26.9705 21.6227 26.7535 22.0026 26.8596L31.8674 29.5668C32.2449 29.6706 32.4704 30.0644 32.3659 30.4394L31.5658 33.3164C31.4614 33.6913 31.0649 33.9154 30.6874 33.8116L23.8046 31.9227H23.8022Z",
    fill: "url(#paint17_linear_3345_2647)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0329 26.0036C28.408 26.1192 28.9684 26.0177 29.277 25.7772L29.2746 25.7749L34.8944 21.4004C35.203 21.1598 35.2576 20.7118 35.0154 20.4052L33.1374 18.0234C32.8953 17.7169 32.4442 17.6626 32.1355 17.9032L24.0799 24.1736C23.7712 24.4142 23.8258 24.7066 24.201 24.8221L28.0329 26.0036Z",
    fill: "url(#paint18_linear_3345_2647)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0329 26.0036C28.408 26.1192 28.9684 26.0177 29.277 25.7772L29.2746 25.7749L34.8944 21.4004C35.203 21.1598 35.2576 20.7118 35.0154 20.4052L33.1374 18.0234C32.8953 17.7169 32.4442 17.6626 32.1355 17.9032L24.0799 24.1736C23.7712 24.4142 23.8258 24.7066 24.201 24.8221L28.0329 26.0036Z",
    fill: "url(#paint19_linear_3345_2647)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0329 26.0036C28.408 26.1192 28.9684 26.0177 29.277 25.7772L29.2746 25.7749L34.8944 21.4004C35.203 21.1598 35.2576 20.7118 35.0154 20.4052L33.1374 18.0234C32.8953 17.7169 32.4442 17.6626 32.1355 17.9032L24.0799 24.1736C23.7712 24.4142 23.8258 24.7066 24.201 24.8221L28.0329 26.0036Z",
    fill: "url(#paint20_linear_3345_2647)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3345_2647",
    x1: 4.82227,
    y1: 36.7086,
    x2: 24.7967,
    y2: 16.7399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A3FFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A3FFC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3345_2647",
    x1: 8.90238,
    y1: 34.2448,
    x2: 35.1742,
    y2: 7.98054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D68FC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2D68FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D68FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3345_2647",
    x1: 10.4399,
    y1: 32.7068,
    x2: 40.9026,
    y2: 2.25298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50B7F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50B7F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3345_2647",
    x1: 4.82227,
    y1: 36.7086,
    x2: 24.7967,
    y2: 16.7399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A3FFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A3FFC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3345_2647",
    x1: 8.90238,
    y1: 34.2448,
    x2: 35.1742,
    y2: 7.98054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D68FC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2D68FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D68FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3345_2647",
    x1: 10.4399,
    y1: 32.7068,
    x2: 40.9026,
    y2: 2.25298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50B7F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50B7F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3345_2647",
    x1: 4.82227,
    y1: 36.7086,
    x2: 24.7967,
    y2: 16.7399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A3FFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A3FFC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3345_2647",
    x1: 8.90238,
    y1: 34.2448,
    x2: 35.1742,
    y2: 7.98054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D68FC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2D68FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D68FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3345_2647",
    x1: 10.4399,
    y1: 32.7068,
    x2: 40.9026,
    y2: 2.25298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50B7F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50B7F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3345_2647",
    x1: 4.82227,
    y1: 36.7086,
    x2: 24.7967,
    y2: 16.7399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A3FFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A3FFC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3345_2647",
    x1: 8.90238,
    y1: 34.2448,
    x2: 35.1742,
    y2: 7.98054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D68FC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2D68FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D68FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3345_2647",
    x1: 10.4399,
    y1: 32.7068,
    x2: 40.9026,
    y2: 2.25298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50B7F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50B7F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3345_2647",
    x1: 4.82227,
    y1: 36.7086,
    x2: 24.7967,
    y2: 16.7399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A3FFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A3FFC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3345_2647",
    x1: 8.90238,
    y1: 34.2448,
    x2: 35.1742,
    y2: 7.98054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D68FC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2D68FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D68FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3345_2647",
    x1: 10.4399,
    y1: 32.7068,
    x2: 40.9026,
    y2: 2.25298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50B7F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50B7F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3345_2647",
    x1: 4.82227,
    y1: 36.7086,
    x2: 24.7967,
    y2: 16.7399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A3FFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A3FFC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3345_2647",
    x1: 8.90238,
    y1: 34.2448,
    x2: 35.1742,
    y2: 7.98054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D68FC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2D68FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D68FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3345_2647",
    x1: 10.4399,
    y1: 32.7068,
    x2: 40.9026,
    y2: 2.25298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50B7F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50B7F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3345_2647",
    x1: 4.82227,
    y1: 36.7086,
    x2: 24.7967,
    y2: 16.7399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A3FFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A3FFC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3345_2647",
    x1: 8.90238,
    y1: 34.2448,
    x2: 35.1742,
    y2: 7.98054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D68FC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2D68FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D68FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3345_2647",
    x1: 10.4399,
    y1: 32.7068,
    x2: 40.9026,
    y2: 2.25298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50B7F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50B7F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatDoazgpt);
export default __webpack_public_path__ + "static/media/chatDoazgpt.ac21b6a33d39080dd8bccb24d0da05d2.svg";
export { ForwardRef as ReactComponent };